module.exports = __webpack_public_path__ + "img/tn-stock-9.79092a84.jpeg";